<template lang="pug">
  v-container(fluid fill-height class="ma-0 pa-0")
    v-img(height="100%" width="100%")
      l-map(
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
      style="height: 89vh",
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate",
        @click="mapclick",
        ref="myMap"
        :maxZoom="19"
      )
        l-tile-layer(:url="url" :attribution="attribution" :options="layerOptions" :tile-layer-class="tileLayerClass")
        l-marker(v-for="m in chargingMarkers" :key="m.id" :lat-lng="m.LatLng" :icon="getIcon(m)")
          l-popup {{ m.name }}    
        l-polyline(v-if="routeData" ":lat-lngs"="latLngs" :color="colourForTrip(trip != null ? trip.id : 1)")
        v-rotated-marker(v-for="carLocation in carLocations" :key="carLocation.id" :lat-lng="carLocation" :icon="carIcon" :rotationAngle="carLocation.bearing" @click="carClicked(carLocation)")
          l-popup {{ carLocation.name }}   
</template>

<script>
import MapSupport from "../mixins/MapSupport.js";
import Geotab from '../services/api/Geotab.js';
import L from "leaflet";
export default {
  mixins:[MapSupport],
  name: "Map",
  props: ["routeMarkers", "routeData", "chargers", "trip", "myCar"],
  data() {
    return {
            carIcon: L.icon({
            iconUrl: "https://powersell.appstack.me/icons/car-top-view.png",
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [0, -40] 
          })
    }
  },
  computed: {
    latLngs() {
      let latlngs = [];
      if (this.routeData && this.routeData.points) {
        for (let p of this.routeData.points) {
          latlngs.push([p[1], p[0]]);
        }
      }
            if (this.$refs.myMap && latlngs.length > 0) {
        this.$refs.myMap.mapObject.fitBounds(latlngs);
      } else {
        if (this.$refs.myMap) this.$refs.myMap.mapObject.setZoom(6);
      }
      return latlngs;
    },
    chargingMarkers() {

      let markers = [];
      if (this.routeData != null && this.routeData.charging_steps) {
        for (let ch of this.routeData.charging_steps) {
          let m = JSON.parse(JSON.stringify(ch));
          m.LatLng = { lat: m.location[1], lng: m.location[0] };

          let c = this.getChargerByID(m.id);
          if (c != null) {
            m.Current = c.Current;
            m.KwRated = c.KwRated;
            m.Charger = c;
          }
          markers.push(m);
        }
      }

      return markers;
    }
  },
  methods: {
    async updateMyCar() {
      if (this.myCar && this.myCar.name) {
        let status = await Geotab.getDeviceStatus(this.myCar.id);

        let soc = await Geotab.getStateOfCharge(this.myCar.id);

        this.myCar.soc = soc;
        this.myCar.status = status;
        this.$emit("updateCar",this.myCar);
      
      }
    
    },
    async carClicked(location) {
              let status = await Geotab.getDeviceStatus(location.id);

        let soc = await Geotab.getStateOfCharge(location.id);

        this.myCar.soc = soc;
        this.myCar.status = status;
        this.$emit("updateCar",this.myCar);
      this.$emit("changeCar",location.car);
    }
  },
  asyncComputed: {
      async carLocations() {
        let locations = [];
        for (let i = 0; i < this.$user.geotab.length; i++) {
          let g = this.$user.geotab[i];
        
       
           let car = await Geotab.getCarData(g.Name);
           let status = await Geotab.getDeviceStatus(car.id);
           locations.push({id:car.id,lat:status.latitude,lng:status.longitude, bearing: status.bearing, name:car.name, car:g});
        }
        return locations;
     /* if (this.myCar && this.myCar.name) {
        let status = await Geotab.getDeviceStatus(this.myCar.id);

        let soc = await Geotab.getStateOfCharge(this.myCar.id);

        this.myCar.soc = soc;
        this.myCar.status = status;
        this.$emit("updateCar",this.myCar);
        return {lat:status.latitude,lng:status.longitude, bearing: status.bearing};
      }
      return null;*/
    },
  }
};
</script>
<style scoped>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>